import $ from 'jquery'
import mobile from 'scoreboard/components/mobile'
import deviceType from 'scoreboard/components/device-type'

// ff needs this as of 7/30/2015
function autofocus(el) {
	var target = $(el).find('[autofocus]').length != 0 ?
		$(el).find('[autofocus]') :
		$(el).find('.autofocus')
	// focus(), when called on an element inside the display pane, causes the
	// mobile menu to collapse prematurely. So if the mobile menu isn't open, focus
	// like normal, otherwise, append a class so that the element can be focused
	// when the menu is closed in main.js
	if(!mobile.isMobileMenuVisible()) {
		// iOS has a built in "feature" that doesn't allow autofocus on load until there
		// is user interaction, so we will disable it for those devices. Issue #17460
		if (!deviceType.iOS) {
			target.focus().removeClass('autofocus')
		}
	} else {
		target.addClass('autofocus')
	}
}

export default autofocus

autofocus.__filename__ = 'polyfills/autofocus.js'
